import { ShoppingCart, Calendar, LogIn } from 'lucide-react'

interface NotificationItem {
  id: string
  type: "purchase" | "booking" | "login"
  title: string
  description: string
  time: string
}

export function NotificationSettings() {
  const notifications: NotificationItem[] = [
    {
      id: "1",
      type: "purchase",
      title: "Purchase Alert",
      description: "Olatunji just bought velvet kiss lipstick",
      time: "23mins ago"
    },
    {
      id: "2",
      type: "booking",
      title: "Bookings",
      description: "Sharon just booked Birthday glam",
      time: "1h ago"
    },
    {
      id: "3",
      type: "booking",
      title: "Bookings",
      description: "Yinka just booked Wedding glam",
      time: "1h ago"
    },
    {
      id: "4",
      type: "login",
      title: "Login from 192.168.24",
      description: "",
      time: "1h ago"
    }
  ]

  const getIcon = (type: NotificationItem["type"]) => {
    switch (type) {
      case "purchase":
        return <ShoppingCart className="h-4 w-4" />
      case "booking":
        return <Calendar className="h-4 w-4" />
      case "login":
        return <LogIn className="h-4 w-4" />
    }
  }

  return (
    <div className="space-y-6">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className="flex items-start gap-4 pb-4 border-b last:border-b-0"
        >
          <div className="mt-1 text-[#B87775]">
            {getIcon(notification.type)}
          </div>
          <div className="flex-1">
            <h3 className="font-medium">{notification.title}</h3>
            {notification.description && (
              <p className="text-sm text-muted-foreground">
                {notification.description}
              </p>
            )}
          </div>
          <div className="text-sm text-muted-foreground">
            {notification.time}
          </div>
        </div>
      ))}
    </div>
  )
}

